// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"h3-z","colorTextValue":"i3-z","swatches":"j3-z","collapseLink":"k3-z","isCollapsed":"l3-z","dropdown":"m3-z","disabled":"n3-z"};